"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = __importDefault(require("./constants"));

var format_1 = __importDefault(require("./format"));

var splitByIndex_1 = __importDefault(require("./helpers/splitByIndex"));

var checkPhoneValidity_1 = __importDefault(require("./helpers/checkPhoneValidity"));

var emptyReturn_1 = __importDefault(require("./constants/emptyReturn"));

var phoneUtils = function phoneUtils(phoneNumber) {
  var _a, _b;

  if (!phoneNumber) return emptyReturn_1.default;
  var phone = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/[^\d.-]/g, "");
  var unformatted = (_a = "".concat(phone)) === null || _a === void 0 ? void 0 : _a.substring("".concat(phone).length - constants_1.default.shortLength);
  var phoneTelco = (_b = constants_1.default === null || constants_1.default === void 0 ? void 0 : constants_1.default.telcos) === null || _b === void 0 ? void 0 : _b.find(function (t) {
    return unformatted.startsWith("".concat(t.value));
  });

  var _checkPhoneValidity_ = checkPhoneValidity_1.default(phone, phoneTelco),
      isValid = _checkPhoneValidity_.isValid,
      errorMessage = _checkPhoneValidity_.message;

  return {
    isValid: isValid,
    error: isValid ? null : errorMessage,
    normalized: isValid ? "250".concat(unformatted) : null,
    formatted: isValid ? "+(".concat(constants_1.default.prefix, ") ").concat(splitByIndex_1.default(unformatted, 3)) : null,
    unformatted: isValid ? "".concat(constants_1.default.prefix).concat(unformatted) : phoneNumber,
    telco: phoneTelco ? phoneTelco === null || phoneTelco === void 0 ? void 0 : phoneTelco.label : null,
    short: isValid ? unformatted : null,
    dashed: isValid ? "+(".concat(constants_1.default.prefix, ")-").concat(splitByIndex_1.default(unformatted, 3, "dash")) : null,
    format: function format(shape) {
      return this.isValid ? format_1.default(unformatted, shape) : constants_1.default.errors.invalid;
    }
  };
};

exports.default = phoneUtils; // TODO
// - configure eslint and prettier
// - refactor format
// - add all possible format